import { selectCurrentFolderId } from 'ducks/searches/selectors/selectCurrentFolderId'
import { createBasicSelector } from 'util/redux'
import { selectCurrentFoldersById } from '.'

export const selectCurrentQueryFolder = createBasicSelector(
  selectCurrentFoldersById,
  selectCurrentFolderId,
  (byId, folderId) => (folderId ? byId[folderId] : null)
)
